const ValuesSection = () => {
  const values = [
    { title: "Chất lượng", description: "Sản phẩm chính hãng 100%." },
    { title: "Uy tín", description: "Cam kết bảo hành đúng tiêu chuẩn." },
    { title: "Tận tâm", description: "Luôn đặt khách hàng lên hàng đầu." },
    { title: "Đổi mới", description: "Cập nhật sản phẩm mới nhất từ Apple." },
  ];

  return (
    <section className="w-full bg-gradient-to-r from-[#E5F5FA] to-[#0AA4DA] py-16 px-6 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl lg:text-4xl font-bold text-center text-gray-800 mb-8">
          Giá Trị Cốt Lõi Của Chúng Tôi
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white shadow-md p-6 rounded-lg text-center"
            >
              <h3 className="text-xl font-bold text-primaryColor mb-4">
                {value.title}
              </h3>
              <p className="text-gray-600">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
